import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";
import { store } from "../../../../utils/store";

export type CallLogQuery = {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  status?: string;
  phone?: string;
  dashboard?: boolean;
  period?: string;
  from?: string;
  to?: string;
  teamId?: string;
  teamIds?: string;
  agentIds?: string;
  projectIds?: string;
  sources?: string;
  stages?: string;
  focus?: string;
};

export async function getAllCallLogs(payload: CallLogQuery) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      page: String(payload.pageNumber ?? 0),
      limit: String(payload.pageSize ?? 25),
      search: payload.search || "",
      status: payload.status || "",
      phone: payload.phone || "",
    });
    if (payload.dashboard) qs.set("dashboard", "1");
    if (payload.period) qs.set("period", payload.period);
    if (payload.from) qs.set("from", payload.from);
    if (payload.to) qs.set("to", payload.to);
    if (payload.teamId) qs.set("teamId", payload.teamId);
    if (payload.teamIds) qs.set("teamIds", payload.teamIds);
    if (payload.agentIds) qs.set("agentIds", payload.agentIds);
    if (payload.projectIds) qs.set("projectIds", payload.projectIds);
    if (payload.sources) qs.set("sources", payload.sources);
    if (payload.stages) qs.set("stages", payload.stages);
    if (payload.focus) qs.set("focus", payload.focus);
    const orgId = String(store.getState().auth?.activeOrganizationId || "").trim();
    if (orgId && orgId !== "all" && orgId !== "*") qs.set("organizationId", orgId);
    const response = await makeCall(
      `${urls.CALLLOGDATA}?${qs.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getCallRecordings(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.RECORDINGURL}?file=${payload || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
